import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9eb61e90"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex justify-between items-center mt-5",
  key: "profile"
}
const _hoisted_2 = { class: "w-auto flex justify-between space-x-6" }
const _hoisted_3 = { class: "w-[21rem]" }
const _hoisted_4 = {
  key: 1,
  class: "flex items-center w-auto space-x-4 pl-2"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  class: "w-[27rem] flex justify-between mt-8",
  key: "profile2"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hover:text-v_green hover:underline hover:decoration-v_green hover:underline-offset-[1rem] hover:decoration-2" }, " Limpar pesquisa ", -1))
const _hoisted_8 = [
  _hoisted_7
]

import { onMounted } from "vue"
import {
	HeaderContainer,
	H2,
	Button,
	TotalValueContainer,
} from "@/components/atoms"
import DataTable from "../molecules/DataTable.vue"
import {
	checkCompanySendingPermission,
	getCodRev,
	getNewFlowAlert,
	hasPermission,
	setNewFlowAlert,
} from "@/utils/permissions"
import { Permission, Profile, Situations, Status } from "@/utils/enum"
import CommissionModal from "../molecules/CommissionModal.vue"
import NewUserModal from "../molecules/NewUserModal.vue"
import UserDataTable from "../molecules/UserDataTable.vue"
import UserModalVue from "../molecules/UserModal.vue"
import ModalChangePassword from "../molecules/ModalChangePassword.vue"
import SnackbarLimitInvoice from "../molecules/SnackbarLimitInvoice.vue"
import { Notification } from "@/utils/enum"
import Notifications from "../molecules/Notifications.vue"
import NoteSendingModal from "../molecules/NoteSendingModal.vue"
import { ref, watch } from "vue"
import { computed } from "vue"
import NoteInformationModal from "../molecules/NoteInformationModal.vue"
import FAQ from "./FaqInternal.vue"
import {
	IData,
	ICommissionSearch,
	IGetCommission,
	Commissions,
	IResales,
	Commission,
	IPendingAttachment,
} from "@/utils/interfaces"

import {
	getAllCommissions,
	getCommission,
	getTotalCommissions,
} from "@/repositories/commissions"
import Header from "../molecules/Header.vue"
import {
	SAVE_USER_PAGINATION,
	SAVE_USER_ITENS_PER_PAGE,
} from "@/store/mutationsTypes"
import { useStore } from "@/store"
import { VueSpinner } from "vue3-spinners"
import { downloadReport } from "@/repositories/downloadReport"
import { companies } from "@/utils/companies"
import CompanyModalSimple from "../molecules/CompanyModalSimple.vue"
import {
	formatCurrencyBRL,
	formatDate,
	formatStringToBool,
	isNegativeNumber,
} from "@/utils/formatters"
import AttachmentSendingModal from "../molecules/AttachmentSendingModal.vue"
import AlertNewFlowModal from "../molecules/AlertNewFlowModal.vue"
import { useClient } from "@/clients/AxiosClient"
import { Routes } from "@/utils/enum"
import { getCommissionLimitByBase } from "@/utils/commissionLimits"


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  emits: ["enableLoading"],
  setup(__props, { emit }) {

const store = useStore()

let canSend = ref(true)
let profile = ref(Profile.COMMISSION)
let showNoteInfoModal = ref(false)
let type = ref(false)
let eyeIcon = ref(false)
let showModal = ref(false)
let showNewUserModal = ref(false)
let showModalChangePassword = ref(false)
let showUserModal = ref(false)
let showProfile = ref(Profile.COMMISSION)
let showNotification = ref(false)
let showNoteSendingModal = ref(false)
let showLimitInvoicesnackbar = ref(false)
let commissions = ref<Commission[]>([])
let title = ref("titulo")
let subtitle = ref("subtitulo")
let totalPages = ref(0)
let page = ref(1)
let data = ref<IData[]>([])
let total = ref("")
let perPage = ref(10)
let resaleUser = ref<IResales[]>([])
let situation = ref("")
let showSituation = ref("")
let tableKey = ref(0)
let userKey = ref(0)
let paginationKey = ref(0)
let itensPerPageKey = ref(0)
let showTotalValue = ref(false)
let negativeValue = ref(false)
let pendingAttachment = ref<IPendingAttachment>({
	hasPending: false,
})
let hasNewFlow = ref(false)
let canShowTomador = ref(false)

let company = ref(store.state.selectedCompany)
const selectedBase = computed(() => store.getters.getCommissionFilter.base)
const maxRowsByBase = computed(() => getCommissionLimitByBase(selectedBase.value))

watch(
	() => store.state.selectedCompany,
	(newVal) => {
		company.value = newVal;
		
		canShowTomador.value = false;
		if(["RB Code Matriz", "RB Code Filial"].includes(newVal))
			canShowTomador.value = true;
	}
)



const changeBase = (base: string) => {
	canSend.value = checkCompanySendingPermission(base)
}

const emitMessage = (value: boolean, Title: string, Subtitle: string) => {
	showNotification.value = value
	title.value = Title
	subtitle.value = Subtitle
}

const selectAllCommission = (data: any[]) => {
	commissions.value = data.map((d): Commission => {
		return {
			note: d.note,
			brute: d.groosCommission,
			adjustment: d.adjustment,
			client: d.client,
			discount: d.discount,
			total: d.netCommission,
			provision_Id: d.provision_Id,
			base: d.base,
			id: d.id,
		}
	})
}

const clearAllCommissions = () => {
	commissions.value = []
	tableKey.value = new Date().getMilliseconds()
}

const removeSelectedCommission = (id: number) => {
	commissions.value = commissions.value.filter((e) => e.id != id)
}

const setItemsPerPage = (value: any, typeValue: string) => {
	if (value == -1) {
		takeAllCommissions()
	} else {
		getCommissionsPerPage(value, typeValue)
	}
}

const setPagination = (value: number, typeValue: string) => {
	getCommissionsPerPage(value, typeValue)
}

const clearTableAfterSearchError = () => {
	data.value = []
	totalPages.value = 0
	showSituation.value = ""
	situation.value = ""
	eyeIcon.value = false
	total.value = ""
	tableKey.value = new Date().getMilliseconds()
}

const unsentNote = (message?: string) => {
	closeNoteSendingModal()

	emitMessage(
		true,
		Notification.TITLE_ERROR_SEND_REQUEST,
		message ?? Notification.SUBTITLE_ERROR_SEND_REQUEST
	)
}

const closeNoteSendingModal = () => {
	showNoteSendingModal.value = false
	commissions.value = []
	tableKey.value = new Date().getMilliseconds()
}

const openNoteSendingModal = () => {
	if (
		commissions.value.length > 0 &&
		commissions.value.length <= maxRowsByBase.value
	) {
		showNoteSendingModal.value = true
	} else if (commissions.value.length > maxRowsByBase.value) {
		showLimitInvoicesnackbar.value = true
	}
}

const changeProfile = (value: Profile) => {
	profile.value = value

	if (value == Profile.COMMISSION) {
		showProfile.value = Profile.COMMISSION
	} else if (value == Profile.USER) {
		showProfile.value = Profile.USER
	} else {
		showProfile.value = Profile.FAQ
	}
}

const enableLoading = (value: boolean) => {
	emit("enableLoading", value)
}

const updateUserDataTable = () => {
	userKey.value = new Date().getMilliseconds()

	clearUserFilter()

	emitMessage(
		true,
		(title.value = Notification.TITLE_USER_EDIT),
		(subtitle.value = Notification.SUBTITLE_USER_EDIT)
	)
}

const createUser = (value: boolean, title: string, subtitle: string) => {
	emitMessage(value, title, subtitle)
	userKey.value = new Date().getMilliseconds()
}

const filterUser = (value: any[]) => {
	resaleUser.value = value.map((v): IResales => {
		const index = Array.from(v.role).findIndex((e: any) => {
			// eslint-disable-next-line
			if (e.name == process.env.VUE_APP_ROLE_REVENDA) {
				return true
			} else if (e.name == process.env.VUE_APP_ROLE_REVENDA_ADMIN) {
				return true
			}

			return false
		})
		return {
			name: v.name,
			username: v.username,
			resaleCode: v.role[index]?.data?.codRev,
			email: v.email,
			id: v.id,
		}
	})

	store.commit(SAVE_USER_PAGINATION, 1)
	store.commit(SAVE_USER_ITENS_PER_PAGE, 10)

	userKey.value = new Date().getMilliseconds()
}

const clearUserFilter = () => {
	if (resaleUser.value.length > 0) {
		resaleUser.value = []
		userKey.value = new Date().getMilliseconds()
	}
}

const showValue = async () => {
	negativeValue.value = false
	let commission = store.getters.getCommissionFilter
	let codRev = ""

	if (hasPermission([Permission.RESALE])) codRev = store.getters.getCodRev

	if (data.value.length > 0 && !eyeIcon.value) {
		eyeIcon.value = true
		type.value = !type.value

		showTotalValue.value = true

		const res = await getTotalCommissions(commission, codRev)

		if (res.status == 200) {
			if (res.message.data.totalAmount <= 0) {
				negativeValue.value = true
			}

			total.value = res.message.data.totalAmount.toLocaleString("pt-BR", {
				style: "currency",
				currency: "BRL",
			})
		} else {
			emitMessage(true, Notification.TITLE_ERROR, Notification.SUBTITLE_ERROR)
		}
	} else {
		eyeIcon.value = false
	}

	showTotalValue.value = false
}

const fetchCommissioAfterSendingTheInvoice = async () => {
	let commission = getStoreCommission()
	let codRev = store.getters.getCodRev

	commission.codRev = codRev

	const res = await getCommission(commission)

	if (res.status === 200) {
		parseCommissionsData(res.message.data, commission.base)

		totalPages.value = res.message.pagesNum

		emitMessage(
			true,
			Notification.TITLE_REQUEST_SENT,
			Notification.SUBTITLE_REQUEST_SENT
		)
	} else {
		//Se houver algum erro na busca de comissões ele cai aqui,
		//retorna os valores pro estado inicial e exibi a mensagem de sucesso para o envio da nota.
		emitMessage(
			true,
			Notification.TITLE_REQUEST_SENT,
			Notification.SUBTITLE_REQUEST_SENT
		)
		clearTableAfterSearchError()
	}

	closeNoteSendingModal()

	pendingAttachment.value = await getPendingAttachment()
}

const fetchCommissionAfterAdjusting = async () => {
	let commission = getStoreCommission()

	const res = await getCommission(commission)

	if (res.status === 200) {
		parseCommissionsData(res.message.data, commission.base)

		totalPages.value = res.message.pagesNum

		emitMessage(
			true,
			Notification.TITLE_ADJUSTED_COMMISSION,
			Notification.SUBTITLE_ADJUSTED_COMMISSION
		)
	} else {
		emitMessage(true, Notification.TITLE_ERROR, Notification.SUBTITLE_ERROR)
		tableKey.value = new Date().getMilliseconds()
	}

	enableLoading(false)
}

const getAvailableCommission = (item: any) => {
	commissions.value = item.map((item: any) => {
		return {
			note: item.note,
			brute: item.groosCommission,
			adjustment: item.adjustment,
			client: item.client,
			discount: item.discount,
			total: item.netCommission,
			provision_Id: item.provision_Id,
			base: item.base,
			id: item.id,
		}
	})
}

const getStoreCommission = () => {
	let commission: IGetCommission = store.getters.getCommissionFilter

	return commission
}

const getReport = async () => {
	enableLoading(true)

	const commission = getStoreCommission()

	const res: any = await downloadReport(commission)

	if (res?.status == 200) {
		const date = new Date()
			.toISOString()
			.split("T")[0]
			.split("-")
			.reverse()
			.join("/")

		let name = store.getters.getResaleName

		if (name == "") name = "AIDC"

		const url = window.URL.createObjectURL(new Blob([res.data]))

		const link = document.createElement("a")
		link.href = url
		link.setAttribute(
			"download",
			`${name} - ${commission.situation.toLowerCase()} - ${date}.xlsx`
		)
		link.click()
	} else {
		emitMessage(
			true,
			"Error no download",
			"Houve um erro inesperado no download. Por favor, refaça a operação"
		)
	}

	enableLoading(false)
}

const takeAllCommissions = async () => {
	enableLoading(true)

	let commission = getStoreCommission()

	const codRev = store.getters.getCodRev

	commission.codRev = codRev

	const res: any = await getAllCommissions(commission)

	if (res?.status === 200) {
		parseCommissionsData(res.message.data, commission.base)
		totalPages.value = 0

		perPage.value = res.message.data.length
	} else if (res == 404) {
		emitMessage(
			true,
			Notification.TITLE_COMMISSION_NOT_FOUND,
			`${Notification.SUBTITLE_COMMISSION_NOT_FOUND} ${String(
				commission.situation
			).toLowerCase()}`
		)
	} else if (res?.status == 500) {
		emitMessage(true, Notification.TITLE_ERROR, Notification.SUBTITLE_ERROR)
	}

	enableLoading(false)
}

const getCommissions = (value: ICommissionSearch) => {
	perPage.value = 10

	eyeIcon.value = false

	let commissions = value

	totalPages.value = commissions.pagesNum

	let commission = getStoreCommission()

	parseCommissionsData(commissions.data, commission.base)

	paginationKey.value = new Date().getMilliseconds()
	itensPerPageKey.value = new Date().getMilliseconds()
}

const getCommissionsPerPage = async (value: number, typeValue: string) => {
	enableLoading(true)

	commissions.value = []

	let commission = getStoreCommission()

	if (typeValue == "itemsPerPage") {
		commission.pageSize = value
	} else if (typeValue == "pagination") {
		commission.pageNum = value
	}

	if (hasPermission([Permission.RESALE])) {
		const codRev = store.getters.getCodRev

		commission.codRev = codRev
	}

	const res = await getCommission(commission)

	if (res.status === 200) {
		parseCommissionsData(res.message.data, commission.base)

		totalPages.value = res.message.pagesNum

		enableLoading(false)
	} else {
		emitMessage(true, Notification.TITLE_ERROR, Notification.SUBTITLE_ERROR)
		enableLoading(false)
	}

	//Essa validação não foi feito no primeiro if, porque a atualização do valor de perPage || page estava reenderizando a tabela antes da hora
	if (typeValue == "itemsPerPage") {
		perPage.value = value
	} else if (typeValue == "pagination") {
		page.value = value
	}
}

const parseCommissionsData = (values: Commissions[], base: string) => {
	const showCustomerName = formatStringToBool(
		process.env.VUE_APP_SHOW_CLIENT_NAME
	)

	data.value = values.map((d: Commissions): IData => {
		return {
			id: d.id,
			base,
			client: showCustomerName ? d.sap_customer_card_name : "-",
			note: d.invoice_number,
			portion: d.installment,
			validate: formatDate(d.due_date),
			groosCommission: formatCurrencyBRL(d.gross_commission),
			discount: `-${formatCurrencyBRL(d.taxes)}`,
			adjustment: formatCurrencyBRL(d.adjustments_value || 0),
			netCommission: formatCurrencyBRL(d.net_commission),
			totalNetCommission: formatCurrencyBRL(d.total_net_commission),
			provision_Id: d.Provisao_Id || 0,
			customerNote: d.reseller_invoice_number || "",
			paymentDate:
				d.payment_date != undefined ? formatDate(d.payment_date) : "",
			negativeValue:
				d.adjustments_value == null || isNegativeNumber(d.adjustments_value),
			negativeNetCommission: isNegativeNumber(d.net_commission),
			negativeGroosCommission: isNegativeNumber(d.gross_commission),
			negativeTotalNetCommission: isNegativeNumber(d.total_net_commission),
			totalPortion: d.installments_quantity,
			totalSales: Number(d.total_sale),
			canceled: formatStringToBool(d.is_cancellation),
			devolution: formatStringToBool(d.is_devolution),
			status: formatStringToBool(d.is_cancellation)
				? "cancelada"
				: formatStringToBool(d.is_devolution)
				? "devolvida"
				: "",
		}
	})
	tableKey.value = new Date().getMilliseconds()
}

const closeNewFlowAlert = async () => {
	hasNewFlow.value = false;
	setNewFlowAlert("true");
	pendingAttachment.value = await getPendingAttachment()
	enableLoading(false)
}

async function getPendingAttachment() {
	const response: any = await useClient().get(
		Routes.GET_PENDING_ATTACHMENT + `?codRevendaSQL=${getCodRev()}`
	)
	if (response.status == 200) {
		return response.data
	}

	return { hasPending: false }
}

watch(
	store.state.commissionsFilter,
	(n) => {
		const base: string = n.base
		debugger
		console.log(base)
		canSend.value = checkCompanySendingPermission(base)
	},
	{ deep: true }
)

onMounted(async () => {
	try
	{
		if(new Date() <= new Date(2026, 4, 15, 23, 59, 59) && getNewFlowAlert() == "false")
			hasNewFlow.value = true

		if(!hasNewFlow.value)
			pendingAttachment.value = await getPendingAttachment()
	}
	catch (error)
	{
		console.error("Erro durante inicialização:", error)
	}
	finally
	{
		enableLoading(false)
	}
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createBlock(_unref(HeaderContainer), null, {
    default: _withCtx(() => [
      (_unref(showNoteInfoModal))
        ? (_openBlock(), _createBlock(NoteInformationModal, {
            key: 0,
            commissions: _unref(commissions),
            onCloseNoteInfoModal: _cache[0] || (_cache[0] = (value) => _isRef(showNoteInfoModal) //@ts-ignore
 ? showNoteInfoModal.value = value : showNoteInfoModal = value)
          }, null, 8, ["commissions"]))
        : _createCommentVNode("", true),
      (_unref(showModal))
        ? (_openBlock(), _createBlock(CommissionModal, {
            key: 1,
            onCloseModal: _cache[1] || (_cache[1] = (value) => _isRef(showModal) //@ts-ignore
 ? showModal.value = value : showModal = value),
            onGetCommissions: getCommissions,
            onShowLoading: enableLoading,
            onEmitError: emitMessage,
            onSituation: _cache[2] || (_cache[2] = (value) => _isRef(situation) //@ts-ignore
 ? situation.value = value : situation = value),
            onShowSituation: _cache[3] || (_cache[3] = (value) => _isRef(showSituation) //@ts-ignore
 ? showSituation.value = value : showSituation = value),
            onClearTable: clearTableAfterSearchError,
            onSelectedBase: changeBase
          }))
        : _createCommentVNode("", true),
      (_unref(showNewUserModal))
        ? (_openBlock(), _createBlock(NewUserModal, {
            key: 2,
            onCloseNewUserModal: _cache[4] || (_cache[4] = (value) => _isRef(showNewUserModal) //@ts-ignore
 ? showNewUserModal.value = value : showNewUserModal = value),
            onEmitError: emitMessage,
            onEnableLoading: enableLoading,
            onSuccess: createUser
          }))
        : _createCommentVNode("", true),
      (_unref(showUserModal))
        ? (_openBlock(), _createBlock(UserModalVue, {
            key: 3,
            onCloseUserModal: _cache[5] || (_cache[5] = (value) => _isRef(showUserModal) //@ts-ignore
 ? showUserModal.value = value : showUserModal = value),
            onFilter: filterUser,
            onEnableLoading: enableLoading,
            onEmitError: emitMessage
          }))
        : _createCommentVNode("", true),
      _createVNode(SnackbarLimitInvoice, {
        modelValue: _unref(showLimitInvoicesnackbar),
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(showLimitInvoicesnackbar) ? (showLimitInvoicesnackbar).value = $event : showLimitInvoicesnackbar = $event)),
        maxRows: _unref(maxRowsByBase),
        onCloseModalChangePassword: _cache[7] || (_cache[7] = (value) => _isRef(showLimitInvoicesnackbar) //@ts-ignore
 ? showLimitInvoicesnackbar.value = value : showLimitInvoicesnackbar = value)
      }, null, 8, ["modelValue", "maxRows"]),
      (_unref(showModalChangePassword))
        ? (_openBlock(), _createBlock(ModalChangePassword, {
            key: 4,
            onCloseModalChangePassword: _cache[8] || (_cache[8] = (value) => _isRef(showModalChangePassword) //@ts-ignore
 ? showModalChangePassword.value = value : showModalChangePassword = value ),
            onShowLoading: enableLoading
          }))
        : _createCommentVNode("", true),
      (_unref(showNotification))
        ? (_openBlock(), _createBlock(Notifications, {
            key: 5,
            title: _unref(title),
            subtitle: _unref(subtitle),
            onCloseNotification: _cache[9] || (_cache[9] = (value) => _isRef(showNotification) //@ts-ignore
 ? showNotification.value = value : showNotification = value )
          }, null, 8, ["title", "subtitle"]))
        : _createCommentVNode("", true),
      (_unref(showNoteSendingModal))
        ? (_openBlock(), _createBlock(NoteSendingModal, {
            key: 6,
            commissions: _unref(commissions),
            onEmitError: unsentNote,
            onEnableLoading: enableLoading,
            onCloseNoteSendingModal: closeNoteSendingModal,
            onSuccessSendingNote: fetchCommissioAfterSendingTheInvoice,
            onShowModal: _cache[10] || (_cache[10] = (value) => _isRef(showNoteInfoModal) //@ts-ignore
 ? showNoteInfoModal.value = value : showNoteInfoModal = value)
          }, null, 8, ["commissions"]))
        : _createCommentVNode("", true),
      _createVNode(Header, {
        onShowModalChangePassword: _cache[11] || (_cache[11] = (value) => _isRef(showModalChangePassword) //@ts-ignore
 ? showModalChangePassword.value = value : showModalChangePassword = value),
        onChangeProfile: changeProfile,
        onEnableLoading: enableLoading,
        onEmitError: emitMessage
      }),
      (_unref(profile) == _unref(Profile).COMMISSION)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(Button), {
                background: "#4AD989",
                color: "#fff",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_isRef(showModal) //@ts-ignore
 ? showModal.value = true : showModal = true)),
                class: "active:scale-90"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Pesquisar ")
                ]),
                _: 1
              }),
              (
						_unref(hasPermission)([_unref(Permission).RESALE]) &&
						_unref(situation) == _unref(Status).AVAILABLE &&
						_unref(canSend)
					)
                ? (_openBlock(), _createBlock(_unref(Button), {
                    key: 0,
                    background: "#fff",
                    class: "active:scale-90",
                    color: "#09092A",
                    bd: "#CFD1E1",
                    onClick: openNoteSendingModal
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Enviar nota ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (
						_unref(hasPermission)([_unref(Permission).RESALE]) && _unref(situation) == _unref(Status).AVAILABLE
					)
                ? (_openBlock(), _createBlock(_unref(Button), {
                    key: 1,
                    background: "#fff",
                    class: "active:scale-90",
                    color: "#09092A",
                    bd: "#CFD1E1",
                    onClick: takeAllCommissions
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Buscar todas ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(canShowTomador))
                ? (_openBlock(), _createBlock(_unref(H2), {
                    key: 2,
                    class: "self-center"
                  }, {
                    default: _withCtx(() => [
                      (_unref(Situations).AVAILABLE_COMMISSIONS == _unref(showSituation))
                        ? (_openBlock(), _createBlock(CompanyModalSimple, {
                            key: 0,
                            company: _unref(company),
                            informations: _unref(companies)[_unref(company)]
                          }, null, 8, ["company", "informations"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_unref(H2), { class: "self-center" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(showSituation)), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              (_unref(data).length > 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: getReport,
                    class: "my-4 tooltip active:scale-90"
                  }, [
                    _createVNode(_component_v_icon, { icon: "mdi-tray-arrow-down" })
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_unref(TotalValueContainer), { class: "float-right" }, {
                default: _withCtx(() => [
                  (_unref(showTotalValue))
                    ? (_openBlock(), _createBlock(_unref(VueSpinner), {
                        key: 0,
                        size: 30,
                        color: "#343434"
                      }))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("button", {
                          onClick: _withModifiers(showValue, ["prevent"]),
                          class: "active:scale-90"
                        }, [
                          _createVNode(_component_v_icon, {
                            icon: _unref(eyeIcon) ? 'mdi-eye-outline' : 'mdi-eye-off-outline',
                            id: "eyes",
                            class: "text-[#b5bfc9]"
                          }, null, 8, ["icon"])
                        ], 8, _hoisted_5),
                        (_unref(eyeIcon))
                          ? (_openBlock(), _createBlock(_unref(H2), {
                              key: 0,
                              class: _normalizeClass(_unref(negativeValue) ? 'text-v_red' : 'text-v_green')
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(total)), 1)
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : (_openBlock(), _createBlock(_unref(H2), {
                              key: 1,
                              class: "mr-16 flex text"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" R$ "),
                                _createVNode(_component_v_icon, {
                                  icon: "mdi-dots-horizontal",
                                  size: 30
                                })
                              ]),
                              _: 1
                            }))
                      ]))
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(profile) == _unref(Profile).USER)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_unref(Button), {
              background: "#4AD989",
              color: "#fff",
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_isRef(showUserModal) //@ts-ignore
 ? showUserModal.value = true : showUserModal = true)),
              class: "active:scale-90"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Pesquisar ")
              ]),
              _: 1
            }),
            _createVNode(_unref(Button), {
              background: "#fff",
              color: "#09092A",
              class: "active:scale-90",
              bd: "#CFD1E1",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_isRef(showNewUserModal) //@ts-ignore
 ? showNewUserModal.value = true : showNewUserModal = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Novo usuário ")
              ]),
              _: 1
            }),
            (_unref(hasPermission)([_unref(Permission).ADMIN]))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "text-v_dark_blue font-[700] active:scale-90",
                  onClick: clearUserFilter
                }, _hoisted_8))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (
				_unref(hasPermission)([_unref(Permission).RESALE]) &&
				_unref(situation) == _unref(Status).AVAILABLE &&
				!_unref(canSend)
			)
        ? (_openBlock(), _createBlock(_component_v_alert, {
            key: 9,
            class: "p-4 mt-3",
            icon: "$warning",
            text: "Não é possivel enviar outra nota fiscal hoje, pois um envio já foi realizado!",
            type: "warning",
            variant: "tonal",
            outlined: "",
            style: {"font-weight":"600","max-height":"5rem"}
          }))
        : _createCommentVNode("", true),
      (_unref(showProfile) == _unref(Profile).COMMISSION)
        ? (_openBlock(), _createBlock(DataTable, {
            data: _unref(data),
            page: _unref(page),
            "per-page": _unref(perPage),
            "total-pages": _unref(totalPages),
            onGetCommissions: getAvailableCommission,
            onGetPerPage: setItemsPerPage,
            onEnableLoading: enableLoading,
            onEmitError: emitMessage,
            onSuccessInAdjustingTheCommission: fetchCommissionAfterAdjusting,
            onRemoveCommission: removeSelectedCommission,
            onSelectAllCommissions: selectAllCommission,
            onClearAllCommissions: clearAllCommissions,
            onSetPagination: setPagination,
            key: _unref(tableKey)
          }, null, 8, ["data", "page", "per-page", "total-pages"]))
        : _createCommentVNode("", true),
      (_unref(showProfile) == _unref(Profile).USER)
        ? (_openBlock(), _createBlock(UserDataTable, {
            onEmitError: emitMessage,
            onUpdateDataTable: updateUserDataTable,
            onEnableLoading: enableLoading,
            data: _unref(resaleUser),
            key: _unref(userKey)
          }, null, 8, ["data"]))
        : _createCommentVNode("", true),
      (_unref(showProfile) == _unref(Profile).FAQ)
        ? (_openBlock(), _createBlock(FAQ, {
            key: 12,
            onEnableLoading: enableLoading,
            onEmailSent: emitMessage,
            onEmitError: emitMessage
          }))
        : _createCommentVNode("", true),
      (_unref(pendingAttachment).hasPending && !_unref(showNotification))
        ? (_openBlock(), _createBlock(AttachmentSendingModal, {
            key: 13,
            commissions: [],
            "from-home": true,
            pendingAttachment: _unref(pendingAttachment),
            onSuccessSendingNote: fetchCommissioAfterSendingTheInvoice,
            onEmitError: unsentNote,
            onEnableLoading: enableLoading
          }, null, 8, ["pendingAttachment"]))
        : _createCommentVNode("", true),
      (_unref(hasNewFlow))
        ? (_openBlock(), _createBlock(AlertNewFlowModal, {
            key: 14,
            onSuccessSeeingAlert: closeNewFlowAlert,
            onEnableLoading: enableLoading
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})